// extracted by mini-css-extract-plugin
export default {"cls1":"VeloTimePicker-Separator_cls1__yVBit","cls2":"VeloTimePicker-Separator_cls2__kUEfD VeloTimePicker-Separator_cls1__yVBit"};